import { useEffect } from 'react';
import { HAS_CONFIG_LANG_PAGE } from '@commonPackage/constants';
import { useAntLocale } from '@fuxi/eevee-hooks';
import { useLocation } from 'react-router-dom';
import { ZH } from '@yaotai/common-utils';

export const useLangConfig = () => {
  const location = useLocation();
  const { changeLanguage } = useAntLocale();

  const isHidden = (list: string[]) => list.some(item => location.pathname.includes(item));

  useEffect(() => {
    if (isHidden(HAS_CONFIG_LANG_PAGE)) {
      changeLanguage(localStorage.getItem('HAS-CONFIG-LANG') ?? ZH);
    } else {
      changeLanguage(ZH);
    }
  }, [location.pathname]);
};
